<script>
import DonationAppFeeChangeModal from '@/components/fundraisers/donation-app-fee-change-modal.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwCard from '@/components/generic/tw-card.vue'
import donateCommonAppFeesMixin from '@/mixins/donations/donateCommonAppFeesMixin.js'

export default {
  name: 'FundraiserDonationAppFeeCard' ,
  mixins:[donateCommonAppFeesMixin],
  components: { TwCard, TwButton, DonationAppFeeChangeModal },
  props: {
    modelValue: {
      type: Number,
      default: null
    },
    donationAmount: {
      type: Number,
      required: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      EditorActive: false
    }
  },
  computed: {
    proposedAppFeeMinimum() {
      return 1
    },
    proposedAppFeeMaximum() {
      return this.donationAppFeeAmountProposed(this.donationAmount) - 1
    },
    proposedAppFeeMiddle() {
      // we split the difference between minimum and maximum with 2 decimals
      const middle = (this.proposedAppFeeMaximum + this.proposedAppFeeMinimum)/2
      return parseFloat(middle.toFixed(2))
    }
  },
  methods: {
    update(val) {
      this.$emit('update:modelValue', val)
      this.EditorActive = false
    }
  }
}
</script>

<template>
  <div class="bg-amber-50 rounded-lg p-5 text-sm">
    <div v-if="EditorActive">
      <h6>
        Your optional contribution helps keep GroupRev Free
      </h6>
      <div class="mt-4 grid grid-cols-4 gap-2">
        <tw-button size="sm" block :variant="modelValue === proposedAppFeeMaximum? 'white':'outline'" @click="update(proposedAppFeeMaximum)" class="border border-gray-300 hover:bg-amber-100">
          ${{proposedAppFeeMaximum}}
        </tw-button>
        <tw-button size="sm" block :variant="modelValue === proposedAppFeeMiddle? 'white':'outline'" @click="update(proposedAppFeeMiddle)" class="border border-gray-300 hover:bg-amber-100">
          ${{proposedAppFeeMiddle}}
        </tw-button>
        <tw-button size="sm" block :variant="modelValue === proposedAppFeeMinimum? 'white':'outline'" @click="update(proposedAppFeeMinimum)" class="border border-gray-300 hover:bg-amber-100">
          ${{proposedAppFeeMinimum}}
        </tw-button>
        <tw-button size="sm" block variant="outline" @click="$refs.DonationAppFeeChangeModal.open()" class="hover:bg-amber-100">
          Other
        </tw-button>
      </div>
    </div>
    <div v-else>
      <div class="font-bold">
        + <span v-if="modelValue > 0">${{ modelValue }}</span> Optional Contribution
      </div>
      <div class="flex flex-col items-start gap-4 mt-4">
        <span>GroupRev is a free platform enabling organizations to raise millions for causes and projects that impact the world. We rely on the generosity of small contributions like this to maintain the service.</span>
        <tw-button variant="link" @click="EditorActive = !EditorActive" class="underline text-xs">
          Edit Amount
        </tw-button>
      </div>
    </div>
    <donation-app-fee-change-modal ref="DonationAppFeeChangeModal" @update:model-value="update($event)" />
  </div>
</template>

<style scoped>

</style>
